// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiAcquisitionsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';

export type InvalidPolygonReason =
  | 'self_intersection'
  | 'invalid_geometry'
  | 'null_geometry'
  | 'unknown';

export interface InvalidPolygon {
  polygon_id: string;
  median_zone_id: string | null;
  polygon_type?: 'standard' | 'blocking';
  reason: InvalidPolygonReason;
  comment?: string;
  polygon?: google.maps.LatLngLiteral[];
}

interface InvalidPolygonsParams {
  country?: string;
}

interface InvalidPolygonsResponse {
  body: InvalidPolygon[];
  status_code: number;
  success: boolean;
}

export const auditPolygons = apiAcquisitionsPortal.injectEndpoints({
  endpoints: builder => ({
    getInvalidPolygons: builder.query({
      query: ({ country }: InvalidPolygonsParams) =>
        `/polygon/audit?country=${country}`,
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getInvalidPolygons',
        };
        return modelError;
      },
      transformResponse: (
        response: InvalidPolygonsResponse
      ): InvalidPolygon[] => {
        return response.body;
      },
      // Comparte el tag 'Polygons': cuando se guarda/edita un polígono
      // (savePolygons invalida 'Polygons'), la auditoría se marca como stale y
      // se refresca al volver a la pestaña, removiendo los ya corregidos.
      providesTags: ['Polygons'],
    }),
  }),
});

export const {
  useGetInvalidPolygonsQuery,
  useLazyGetInvalidPolygonsQuery,
} = auditPolygons;
